import { LoadingOutlined, UploadOutlined } from "@ant-design/icons";
import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { Button, Modal, Typography, Upload } from "antd";
import { RcFile } from "antd/es/upload/interface";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { post, put } from "~/Services";
import { passengerHost } from "~/Utils";
import { fields } from "../constants";
import { fetchHeaderDropdownDataByStringId } from "../FetchData";
import { useSubCategoriesDocumentDetails } from "./ChildHeaderPas.hooks";

const AddEditslider = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [currentAirport] = useLocalStorage("currentAirport", null);

  const [uploadModal, setUploadModal] = useState<{
    visible: boolean;
    fieldName?: string;
    file?: RcFile;
    uploading?: boolean;
    setValue?: (name: string, value: string) => void;
  }>({
    visible: false,
    fieldName: undefined,
    file: undefined,
    uploading: false,
  });

  const {
    data: editSubCategories,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchSubCategories,
  } = useSubCategoriesDocumentDetails(query.get("editId") || "");

  const {
    data: editSubCategoriesById,
    isLoading: isLoadingSubCategories,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchSubCategories();
    }
  }, [query.get("editId"), query.get("id")]);
  useEffect(() => {
    fetchHeaderDropdownDataByStringId();
  }, []);

  // Normalize parent_id so Select displays label instead of raw id
  const [normalizedParentId, setNormalizedParentId] = useState<any>(null);
  // useEffect(() => {
  //   let mounted = true;
  //   const normalize = async () => {
  //     try {
  //       const options = await fetchHeaderDropdownDataByStringId();
  //       const rawVal = editSubCategoriesById?.payload?.parent_id ?? editSubCategories?.parent_id;

  //       // find field definition to determine if it's multiSelect
  //       const fieldDef = fields.childheaders?.find((f: any) => f.name === "parent_id");
  //       const isMulti = fieldDef?.formType === "multiSelect";

  //       if (rawVal !== undefined && rawVal !== null && rawVal !== "") {
  //         const rawArray = isMulti
  //           ? Array.isArray(rawVal)
  //             ? rawVal
  //             : typeof rawVal === "string"
  //             ? rawVal.split(",").map((v) => v.trim()).filter(Boolean)
  //             : [rawVal]
  //           : [rawVal];

  //         const matchedValues: any[] = [];
  //         for (const rv of rawArray) {
  //           const matched = options.find((opt: any) => String(opt.value) === String(rv) || String(opt.label) === String(rv));
  //           if (matched) matchedValues.push(matched.value);
  //           else matchedValues.push(rv);
  //         }

  //         if (mounted) setNormalizedParentId(isMulti ? matchedValues : matchedValues[0]);
  //       } else {
  //         if (mounted) setNormalizedParentId(rawVal ?? "");
  //       }
  //     } catch (err) {
  //       if (mounted) setNormalizedParentId(editSubCategoriesById?.payload?.parent_id ?? editSubCategories?.parent_id ?? "");
  //     }
  //   };
  //   normalize();
  //   return () => { mounted = false; };

  // }, [editSubCategories, editSubCategoriesById]);
  useEffect(() => {
    let mounted = true;

    const normalize = async () => {
      try {
        const options = await fetchHeaderDropdownDataByStringId();
        const rawVal = editSubCategoriesById?.payload?.parent_id ?? editSubCategories?.parent_id;

        // field settings
        const fieldDef = fields.childheaders?.find((f: any) => f.name === "parent_id");
        const isMulti = fieldDef?.formType === "multiSelect";

        // If rawVal is empty → force blank field
        if (!rawVal || rawVal === "" || rawVal === null) {
          if (mounted) setNormalizedParentId(null);
          return;
        }

        // Process value(s)
        const rawArray = isMulti
          ? Array.isArray(rawVal)
            ? rawVal
            : typeof rawVal === "string"
              ? rawVal
                  .split(",")
                  .map((v) => v.trim())
                  .filter(Boolean)
              : [rawVal]
          : [rawVal];

        const matchedValues: any[] = [];

        for (const rv of rawArray) {
          const matched = options.find(
            (opt: any) => String(opt.value) === String(rv) || String(opt.label) === String(rv)
          );

          // If label exists → use value
          // If label missing → set empty
          if (matched) matchedValues.push(matched.value);
          else matchedValues.push(""); // blank if label not found
        }

        if (mounted) setNormalizedParentId(isMulti ? matchedValues : matchedValues[0]);
      } catch (err) {
        if (mounted) {
          setNormalizedParentId(editSubCategoriesById?.payload?.parent_id ?? editSubCategories?.parent_id ?? null);
        }
      }
    };

    normalize();
    return () => {
      mounted = false;
    };
  }, [editSubCategories, editSubCategoriesById]);

  // const epcApplicationsFormConfig: FormConfig = {
  //   initialValues: {
  //     name: editSubCategoriesById?.payload
  //       ? decodeHTML(editSubCategoriesById?.payload?.name)
  //       : decodeHTML(editSubCategories?.name),
  //     field_malay_title: editSubCategoriesById?.payload
  //       ? decodeHTML(editSubCategoriesById?.payload?.field_malay_title)
  //       : decodeHTML(editSubCategories?.field_malay_title),
  //     field_mandarin_title: editSubCategoriesById?.payload
  //       ? decodeHTML(editSubCategoriesById?.payload?.field_mandarin_title)
  //       : decodeHTML(editSubCategories?.field_mandarin_title),
  //     field_category_id: editSubCategoriesById?.payload
  //       ? decodeHTML(editSubCategoriesById?.payload?.field_category_id)
  //       : decodeHTML(editSubCategories?.field_category_id),
  //     // field_sub_order_seq: editSubCategoriesById?.payload
  //     //   ? decodeHTML(editSubCategoriesById?.payload?.field_sub_order_seq)
  //     //   : decodeHTML(editSubCategories?.field_sub_order_seq),
  //     field_sub_published: editSubCategoriesById?.payload
  //       ? decodeHTML(editSubCategoriesById?.payload?.field_sub_published)
  //       : decodeHTML(editSubCategories?.field_sub_published),
  //   },
  //   fields: fields.sliders,
  // };
  const epcApplicationsFormConfig: FormConfig = {
    initialValues: {
      name_en: editSubCategoriesById?.payload?.name_en || editSubCategories?.name_en || "",
      name_ms: editSubCategoriesById?.payload?.name_ms || editSubCategories?.name_ms || "",
      name_zh: editSubCategoriesById?.payload?.name_zh || editSubCategories?.name_zh || "",

      airports_en: editSubCategoriesById?.payload?.airports_en || editSubCategories?.airports_en || "",
      airports_ms: editSubCategoriesById?.payload?.airports_ms || editSubCategories?.airports_ms || "",
      airports_zh: editSubCategoriesById?.payload?.airports_zh || editSubCategories?.airports_zh || "",

      child_key_en: editSubCategoriesById?.payload?.child_key_en || editSubCategories?.child_key_en || "",
      child_key_ms: editSubCategoriesById?.payload?.child_key_ms || editSubCategories?.child_key_ms || "",
      child_key_zh: editSubCategoriesById?.payload?.child_key_zh || editSubCategories?.child_key_zh || "",

      child_redirect_url_en:
        editSubCategoriesById?.payload?.child_redirect_url_en || editSubCategories?.child_redirect_url_en || "",
      child_redirect_url_ms:
        editSubCategoriesById?.payload?.child_redirect_url_ms || editSubCategories?.child_redirect_url_ms || "",
      child_redirect_url_zh:
        editSubCategoriesById?.payload?.child_redirect_url_zh || editSubCategories?.child_redirect_url_zh || "",

      parent_id:
        normalizedParentId !== null
          ? normalizedParentId
          : editSubCategoriesById?.payload?.parent_id || editSubCategories?.parent_id || "",

      published: editSubCategoriesById?.payload?.published ?? editSubCategories?.published ?? false,

      image_url: editSubCategoriesById?.payload?.image_url
        ? [
            {
              uid: "-1",
              name: "image.jpg",
              status: "done",
              url: editSubCategoriesById?.payload?.image_url,
            },
          ]
        : editSubCategories?.image_url
          ? [
              {
                uid: "-1",
                name: "image.jpg",
                status: "done",
                url: editSubCategories?.image_url,
              },
            ]
          : [],
    },
    fields: fields.childheaders?.map((field: any) => {
      if (field.uploadTrigger) {
        return {
          ...field,
          openUpload: (fieldName: string, setValue: (name: string, value: string) => void) => {
            setUploadModal({ visible: true, fieldName, setValue, file: undefined, uploading: false });
          },
          usedFileType: ".pdf",
        };
      }
      return field;
    }),
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    console.log("data-123", data);
    let imageKeys: any = ["image_url"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "PASSENGER");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    const payload = {
      action: action,
      method: method,
      module: "Passenger Navigation",
      subModule: "passengerHeader_childheaders",
      type: "DEDICATED",
      application: "PASSENGER_ECMS",
      reviewNotes: reviewNotes,
      airportName: currentAirport,
      appList: [
        {
          appName: "PASSENGER_ECMS",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editSubCategories?.id || editSubCategoriesById?.payload?.id }),
        ...data,
        // field_sub_categories_status: true,
        // field_sub_created_at: "2023-11-21T10:01:09",
        // field_sub_updated_at: "2025-11-29T10:01:09"
      },
      status: status,
    };

    // console.log(payload, "tested");
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingSubCategories}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Child Header`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingSubCategories || drilldownLoading}
        config={epcApplicationsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") ? `${passengerHost}/api/get-child-menu-items-taxonomy-data-list/${editSubCategories?.id || editSubCategoriesById?.payload?.id}` : `${passengerHost}/api/create-child-menu-items-taxonomy-data-list`}`,
            `${query.get("editId") ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Header"
      />
      {/* ------------------- UPLOAD POPUP ------------------- */}
      <Modal
        title="Redirect URL Guide"
        open={uploadModal.visible}
        footer={null}
        onCancel={() => setUploadModal({ ...uploadModal, visible: false, file: undefined })}
        width={520}
      >
        <Typography.Paragraph style={{ marginBottom: 12 }}>
          <ol style={{ margin: 0, paddingLeft: 20 }}>
            <li>
              Use <code>/example</code> for pages within this application.
            </li>
            <li>
              Use a full link for external websites (example: <code>https://example.com</code>).
            </li>
            <li>
              Want to use a file? Click <strong>Upload</strong> and paste the link.
            </li>
          </ol>
        </Typography.Paragraph>

        <Upload.Dragger
          accept="*"
          multiple={false}
          showUploadList={false}
          beforeUpload={(file) => {
            setUploadModal((s) => ({ ...s, file }));
            return false;
          }}
        >
          {uploadModal.file ? (
            <p className="ant-upload-text">{uploadModal.file.name}</p>
          ) : (
            <>
              <p className="ant-upload-drag-icon">
                <UploadOutlined />
              </p>
              <p className="ant-upload-text">Click or drag file here</p>
            </>
          )}
        </Upload.Dragger>

        <div style={{ marginTop: 16, textAlign: "right" }}>
          <Button
            type="primary"
            disabled={!uploadModal.file || uploadModal.uploading}
            onClick={async () => {
              if (!uploadModal.file || !uploadModal.fieldName || !uploadModal.setValue) return;

              setUploadModal((s) => ({ ...s, uploading: true }));

              const formData = new FormData();
              formData.append("upload-file", uploadModal.file);
              formData.append("application", "PASSENGER");

              try {
                const res: any = await post("management/upload-file", formData);
                const url = res?.response?.data;
                if (url) {
                  uploadModal.setValue(uploadModal.fieldName, url);
                  openToast({ content: `File uploaded: ${url}`, type: "success" });
                }
              } catch (e) {
                openToast({ content: "Upload failed", type: "error" });
              } finally {
                setUploadModal({ visible: false, fieldName: undefined, file: undefined, uploading: false });
              }
            }}
          >
            {uploadModal.uploading ? (
              <>
                <LoadingOutlined /> Uploading…
              </>
            ) : (
              "Save"
            )}
          </Button>
        </div>
      </Modal>
    </ContentWrapper>
  );
};

export default AddEditslider;
